export const getLiveProgramProgress = (props: any) : number => {
    const divisor = props.duration ?? (props.endTime - props.startTime) ;
    const progressTimeStamp = Math.floor(Date.now()) - props.startTime;

    const progress = (progressTimeStamp * 100) / divisor;
    
    return Math.floor(progress)
}